export default __webpack_public_path__ + "static/SR USA - FDA Registration (Bioterrorism Act) - Statement-7a9f52c6aac5bf9c4f5625dea41ace4b.pdf";